import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import Routes from '../routes.enum.ts';

type Props = {
  skipAhead: boolean;
  path: Routes;
  children: ReactNode;
  rootChildren?: ReactNode;
};

const RegistrationStepGuard: FC<Props> = ({ skipAhead, path, children, rootChildren }) => {
  if (skipAhead) {
    return children;
  }

  // If step is NOT completed, and we are NOT on the step page, we should redirect to the step page
  if (window.location.pathname !== path) {
    return <Navigate to={path} replace />;
  }

  // If step is NOT completed, but we are on the step page, we should show the step page
  return rootChildren;
};

export default RegistrationStepGuard;
